import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Badge, Box, Divider, Paper, Tab } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { api } from '../api';
import PersonalInfo from './PersonDetailPanels/Person';

import WorkPermit from './PersonDetailPanels/WorkPermit';
import OnlineSafetyTraining from './PersonDetailPanels/OnlineSafetyTraining';
import CovidApplication from './PersonDetailPanels/CovidApplication';
import InoutInfo from './PersonDetailPanels/InoutInfo';
import JobInfo from './PersonDetailPanels/JobInfo';
import HealthApplicationPage from './PersonDetailPanels/HealthApplication';

interface PersonDetailProps {
  person_id?: string | number;
  editable?: boolean;
}

enum PersonDetailTab {
  PERSONAL = 'personal',
  JOB = 'job',
  INOUT = 'inout',
  WPM = 'wpm',
  OST = 'ost',
  COVID19 = 'cvd'
}

const PersonDetail: React.FC<PersonDetailProps> = ({ person_id, editable }: PersonDetailProps) => {
  const [tabValue, setTabValue] = useState<PersonDetailTab>(PersonDetailTab.PERSONAL);

  const handleChange = (event: React.SyntheticEvent, newValue: PersonDetailTab) => {
    setTabValue(newValue);
  };

  const [isOLRActive, setIsOLRActive] = useState<boolean>(false);
  const [isOLRTempActive, setIsOLRTempActive] = useState<boolean>(false);

  const [isWPMActive, setIsWPMActive] = useState<boolean>(false);
  const [isWPMTempActive, setIsWPMTempActive] = useState<boolean>(false);

  const [isOSTActive, setIsOSTActive] = useState<boolean>(false);
  const [isOSTTempActive, setIsOSTTempActive] = useState<boolean>(false);

  const [isCVAActive, setIsCVAActive] = useState<boolean>(true);
  const [isCVATempActive, setIsCVATempActive] = useState<boolean>(true);

  const reloadStatus = useCallback(() => {
    if (person_id) {
      api.get(`/person/${person_id}/olr/status`).then((res) => {
        const { data } = res;
        setIsOLRActive(data.is_active);
        setIsOLRTempActive(data.is_temp_active);
      });
      api.get(`/person/${person_id}/wpm/status`).then((res) => {
        const { data } = res;
        setIsWPMActive(data.is_active);
        setIsWPMTempActive(data.is_temp_active);
      });
      api.get(`person/${person_id}/ost/status`).then((res) => {
        const { data } = res;
        setIsOSTActive(data.is_active);
        setIsOSTTempActive(data.is_temp_active);
      });
      api.get(`person/${person_id}/cva/status`).then((res) => {
        const { data } = res;
        setIsCVAActive(data.is_active);
        setIsCVATempActive(data.is_temp_active);
      });
    }
  }, [person_id]);
  useEffect(() => {
    if (person_id) {
      api.get(`/person/${person_id}/olr/status`).then((res) => {
        const { data } = res;
        setIsOLRActive(data.is_active);
        setIsOLRTempActive(data.is_temp_active);
      });
      api.get(`/person/${person_id}/wpm/status`).then((res) => {
        const { data } = res;
        setIsWPMActive(data.is_active);
        setIsWPMTempActive(data.is_temp_active);
      });
      api.get(`person/${person_id}/ost/status`).then((res) => {
        const { data } = res;
        setIsOSTActive(data.is_active);
        setIsOSTTempActive(data.is_temp_active);
      });
      api.get(`person/${person_id}/cva/status`).then((res) => {
        const { data } = res;
        setIsCVAActive(data.is_active);
        setIsCVATempActive(data.is_temp_active);
      });
    }
  }, [person_id]);

  return (
    <Box>
      <Paper sx={{ p: 2 }}>
        <TabContext value={tabValue}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleChange}>
              <Tab
                sx={{ textTransform: 'none' }}
                label="ข้อมูลบุคคล"
                value={PersonDetailTab.PERSONAL}
              />
              <Tab
                sx={{ textTransform: 'none' }}
                label="การเข้า-ออกพื้นที่"
                value={PersonDetailTab.INOUT}
              />
              <Tab
                sx={{ textTransform: 'none' }}
                value={PersonDetailTab.JOB}
                label={
                  isOLRActive || isOLRTempActive ? (
                    'ข้อมูล Online Register'
                  ) : (
                    <Badge
                      color="error"
                      badgeContent=" "
                      variant="dot"
                      sx={{ '& .MuiBadge-badge': { transform: 'scale(1) translate(100%, -50%)' } }}
                    >
                      ข้อมูล Online Register
                    </Badge>
                  )
                }
              />
              <Tab
                sx={{ textTransform: 'none' }}
                value={PersonDetailTab.WPM}
                label={
                  isWPMActive || isWPMTempActive ? (
                    'Work permit'
                  ) : (
                    <Badge
                      color="error"
                      badgeContent=" "
                      variant="dot"
                      sx={{ '& .MuiBadge-badge': { transform: 'scale(1) translate(100%, -50%)' } }}
                    >
                      Work permit
                    </Badge>
                  )
                }
              />
              <Tab
                sx={{ textTransform: 'none' }}
                value={PersonDetailTab.OST}
                label={
                  isOSTActive || isOSTTempActive ? (
                    'Online safety training'
                  ) : (
                    <Badge
                      color="error"
                      badgeContent=" "
                      variant="dot"
                      sx={{ '& .MuiBadge-badge': { transform: 'scale(1) translate(100%, -50%)' } }}
                    >
                      Online safety training
                    </Badge>
                  )
                }
              />
              <Tab
                sx={{ textTransform: 'none' }}
                value={PersonDetailTab.COVID19}
                label={
                  isCVAActive || isCVATempActive ? (
                    'ข้อมูลการตรวจร่างกาย'
                  ) : (
                    <Badge
                      color="error"
                      badgeContent=" "
                      variant="dot"
                      sx={{ '& .MuiBadge-badge': { transform: 'scale(1) translate(100%, -50%)' } }}
                    >
                      ข้อมูลการตรวจร่างกาย
                    </Badge>
                  )
                }
              />
            </TabList>
          </Box>

          <TabPanel value={PersonDetailTab.PERSONAL} sx={{ p: 1, pt: 2 }}>
            <PersonalInfo person_id={person_id} editable={editable} />
          </TabPanel>
          <TabPanel value={PersonDetailTab.INOUT} sx={{ p: 1, pt: 2 }}>
            <InoutInfo person_id={person_id} editable={editable} />
          </TabPanel>
          <TabPanel value={PersonDetailTab.JOB} sx={{ p: 1, pt: 2 }}>
            <JobInfo person_id={person_id} editable={editable} reloadStatus={reloadStatus} />
          </TabPanel>
          <TabPanel value={PersonDetailTab.WPM} sx={{ p: 1, pt: 2 }}>
            <WorkPermit person_id={person_id} editable={editable} reloadStatus={reloadStatus} />
          </TabPanel>
          <TabPanel value={PersonDetailTab.OST} sx={{ p: 1, pt: 2 }}>
            <OnlineSafetyTraining
              person_id={person_id}
              editable={editable}
              reloadStatus={reloadStatus}
            />
          </TabPanel>
          <TabPanel value={PersonDetailTab.COVID19} sx={{ p: 1, pt: 2 }}>
            <Box sx={{ pb: 4 }}>
              <CovidApplication
                person_id={person_id}
                editable={editable}
                reloadStatus={reloadStatus}
              />
            </Box>
            <Divider />
            <Box sx={{ pt: 4 }}>
              <HealthApplicationPage
                person_id={person_id}
                editable={editable}
                reloadStatus={reloadStatus}
              />
            </Box>
          </TabPanel>
        </TabContext>
      </Paper>
    </Box>
  );
};

export default PersonDetail;
